var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CartBase',{attrs:{"items":_vm.items,"order-config":_vm.orderConfig,"container-classes":[
    'fixed top-0 right-0 h-full w-full max-w-md bg-white shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col',
    _vm.isOpen ? 'translate-x-0' : 'translate-x-full'
  ],"container-style":"z-index: 60","show-pin-button":true,"pin-button-type":"pin","show-close-button":true,"is-store-closed":_vm.isStoreClosed,"on-pin":_vm.handlePin,"on-update-quantity":_vm.onUpdateQuantity,"on-remove-item":_vm.onRemoveItem,"on-edit-item":_vm.onEditItem,"on-checkout":_vm.onCheckout,"on-close":_vm.onClose},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{class:[
        'fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity',
        _vm.isOpen ? 'opacity-100' : 'opacity-0'
      ],style:(_vm.isOpen
          ? 'z-index: 55; pointer-events: auto;'
          : 'z-index: 55; pointer-events: none;'),on:{"click":_vm.onClose}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }